import React, { useContext, useEffect } from 'react';
import { KFLButton, KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import DialogHeader from '../../shared/dialog/dialogHeader';
import Translate from '../../shared/localization/localize';
import DialogSection from '../../shared/dialog/dialogSection';
import { TransferDialogs, TransferStatus } from '../../../modules/dialogs/transfer';
import { LocaleCtx } from '../../../contexts/locale.context';
import TxRequestForm from './transferRequestForm';
import TxRequestList from './transferRequestList';
import DialogFooter from '../../shared/dialog/dialogFooter';
import * as m from '../../../modules/dialogs/transfer/messages';
import useTxRequest from '../../../modules/dialogs/transfer/useTxRequest';

const TxDialogReq: React.FC = () => {
  const { translate } = useContext(LocaleCtx);
  const { tx, closePanel, changeScreen, reset } = useTxRequest();

  useEffect(() => {
    if (tx.status === TransferStatus.PENDING) reset();
  }, [tx.status]);

  const content = (
    <>
      <DialogSection>
        <TxRequestForm />
      </DialogSection>
      <DialogSection isMain scrollable>
        <TxRequestList />
      </DialogSection>
    </>
  );

  const nextButton = (
    <KFLButton
      id="dg-transfer-bt-next"
      key="dg-transfer-bt-next"
      onClick={() => changeScreen(TransferDialogs.REQUEST_VALIDATE)}
      disabled={!(tx.devices.length > 0)}
    >
      {translate(m.msgContinueBtn)}
    </KFLButton>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={m.msgHeaderReq} />}
          fnCloseDialog={closePanel}
        />
      }
      sections={[content]}
      footer={
        <DialogFooter
          leftContent={''}
          buttons={[nextButton]}
          fnCloseDialog={closePanel}
        />
      }
    />
  );
};

export default TxDialogReq;
